document.addEventListener("DOMContentLoaded", function() {
  const placeholders = document.querySelectorAll(".cta-product-placeholder");
  if (!placeholders.length) return; 

  placeholders.forEach(function(el) {
    var handle = el.getAttribute("data-handle");
    if (!handle) return;

    fetch("/products/" + handle + ".js")
      .then(res => res.json())
      .then(product => {
        // Find the featured image object to get its real dimensions
        const featuredImage = product.images_info ? product.images_info[0] : null;
        const imgWidth = featuredImage ? featuredImage.width : 800;
        const imgHeight = featuredImage ? featuredImage.height : 800;

        el.innerHTML = `
          <div class="cta-product-wrapper">
            <div class="cta-product-box">
              <div class="cta-product-image">
                <a href="/products/${product.handle}">
                  <img src="${product.featured_image}" 
                       alt="${product.title}" 
                       width="${imgWidth}" 
                       height="${imgHeight}" 
                       loading="lazy">
                </a>
              </div>
              <div class="cta-product-info">
                <h3 class="cta-product-title">
                  <a href="/products/${product.handle}">${product.title}</a>
                </h3>
                <p class="cta-product-price">${(product.price / 100).toLocaleString()} ${Shopify.currency.active}</p>
              </div>
              <form method="post" action="/cart/add" class="cta-cart-form">
                <input type="hidden" name="id" value="${product.variants[0].id}">
                <button type="submit" class="cta-product-button">Add to Cart</button>
              </form>
            </div>
          </div>
        `;
      })
      .catch(err => {
        console.error("Product fetch failed:", err);
        el.innerHTML = "<p>⚠️ Product not found</p>";
      });
  });
});